import { render, staticRenderFns } from "./TitledCardBase.vue?vue&type=template&id=23f9d5f6&scoped=true&"
import script from "./TitledCardBase.vue?vue&type=script&lang=js&"
export * from "./TitledCardBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9d5f6",
  null
  
)

export default component.exports